<div class="w-full overflow-y-auto h-full">
    <div class="w-full p-2">
        <!-- Acesso -->
        <ng-container>
            <div class="w-full py-6">
                <div class="flex w-full">
                    <div class="p-2 rounded-xl bg-blue-100 ml-2 h-[40px]">
                        <mat-icon svgIcon="mat_outline:security" class="icon-size-6 text-blue-600"></mat-icon>
                    </div>
                    <div class="px-3">
                        <div class="w-full leading-10">
                            <span class="text-[17px] font-[500] font-remote">Acesso</span>
                        </div>
                    </div>
                </div>
                <div class="w-full p-4">
                    <div class="w-full flex justify-between items-center py-3 border-b border-b-gray-100">
                        <div class="px-2">
                            <span class="font-inter text-gray-900 text-[14px] font-[500]">Email</span>
                        </div>
                        <div class="px-2 flex items-center gap-3">
                            <span class="font-inter text-gray-400 text-[13px] font-[400]">{{ userEmail || '-' }}</span>
                            <button
                                [disabled]="true"
                                class="w-8 h-8 min-w-[32px] min-h-[32px] flex items-center justify-center rounded-lg bg-gray-300 cursor-not-allowed p-0">
                                <mat-icon class="icon-size-4 text-gray-500" [svgIcon]="'mat_outline:edit'"></mat-icon>
                            </button>
                        </div>
                    </div>
                    <div class="w-full flex justify-between items-center py-3 border-b border-b-gray-100">
                        <div class="px-2">
                            <span class="font-inter text-gray-900 text-[14px] font-[500]">Senha</span>
                        </div>
                        <div class="px-2 flex items-center gap-3">
                            <span class="font-inter text-gray-400 text-[13px] font-[400]">••••••••</span>
                            <button
                                (click)="openChangePasswordModal()"
                                class="w-8 h-8 min-w-[32px] min-h-[32px] flex items-center justify-center rounded-lg bg-blue-600 hover:bg-blue-700 transition-colors duration-200 p-0">
                                <mat-icon class="icon-size-4 text-white" [svgIcon]="'mat_outline:edit'"></mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- Configurações -->
        <ng-container>
            <form [formGroup]="securityForm">
                <div class="w-full py-6">
                    <div class="flex w-full">
                        <div class="p-2 rounded-xl bg-green-100 ml-2 h-[40px]">
                            <mat-icon svgIcon="mat_solid:settings" class="icon-size-6 text-green-600"></mat-icon>
                        </div>
                        <div class="px-3">
                            <div class="w-full leading-10">
                                <span class="text-[17px] font-[500] font-remote">Configurações</span>
                            </div>
                        </div>
                    </div>
                    <div class="w-full p-4 h-full">
                        <!-- Autenticação de dois fatores -->
                        <div class="py-4 flex items-center justify-between opacity-50 cursor-not-allowed">
                            <mat-icon class="w-[36px] h-[36px] pb-[10px]" [svgIcon]="'mat_solid:verified_user'"></mat-icon>
                            <div class="flex-auto ml-2 pr-2">
                                <div class="leading-6">
                                    <span class="text-[15px] font-inter font-[500] text-gray-600">Autenticação de dois fatores</span>
                                </div>
                                <div>
                                    <span class="text-[14px] font-inter font-[400] text-gray-500">Ativar autenticação de dois fatores via email</span>
                                </div>
                            </div>
                            <mat-slide-toggle class="ml-2 cursor-not-allowed" [formControlName]="'twoFactorAuth'" [color]="'primary'" [disabled]="true">
                            </mat-slide-toggle>
                        </div>

                        <!-- Notificação em novos dispositivos -->
                        <div class="py-4 flex items-center justify-between opacity-50 cursor-not-allowed">
                            <mat-icon class="w-[36px] h-[36px] pb-[10px]" [svgIcon]="'mat_solid:notifications_active'"></mat-icon>
                            <div class="flex-auto ml-2 pr-2">
                                <div class="leading-6">
                                    <span class="text-[15px] font-inter font-[500] text-gray-600">Notificação em novos dispositivos</span>
                                </div>
                                <div>
                                    <span class="text-[14px] font-inter font-[400] text-gray-500">Receber notificação quando acessar de um novo dispositivo</span>
                                </div>
                            </div>
                            <mat-slide-toggle class="ml-2 cursor-not-allowed" [formControlName]="'newDeviceNotification'" [color]="'primary'" [disabled]="true">
                            </mat-slide-toggle>
                        </div>

                        <!-- Encerrar outras sessões -->
                        <div class="py-4 flex items-center justify-between opacity-50 cursor-not-allowed">
                            <mat-icon class="w-[36px] h-[36px] pb-[10px]" [svgIcon]="'mat_solid:logout'"></mat-icon>
                            <div class="flex-auto ml-2 pr-2">
                                <div class="leading-6">
                                    <span class="text-[15px] font-inter font-[500] text-gray-600">Encerrar sessões ao alterar senha</span>
                                </div>
                                <div>
                                    <span class="text-[14px] font-inter font-[400] text-gray-500">Desconectar todos os dispositivos automaticamente ao alterar a senha</span>
                                </div>
                            </div>
                            <mat-slide-toggle class="ml-2 cursor-not-allowed" [formControlName]="'logoutOnPasswordChange'" [color]="'primary'" [disabled]="true">
                            </mat-slide-toggle>
                        </div>

                        <!-- Logout automático -->
                        <div class="py-4 flex items-center justify-between opacity-50 cursor-not-allowed">
                            <mat-icon class="w-[36px] h-[36px] pb-[10px]" [svgIcon]="'mat_solid:timer_off'"></mat-icon>
                            <div class="flex-auto ml-2 pr-2">
                                <div class="leading-6">
                                    <span class="text-[15px] font-inter font-[500] text-gray-600">Logout automático por inatividade</span>
                                </div>
                                <div>
                                    <span class="text-[14px] font-inter font-[400] text-gray-500">Desconectar automaticamente após 30 minutos de inatividade</span>
                                </div>
                            </div>
                            <mat-slide-toggle class="ml-2 cursor-not-allowed" [formControlName]="'autoLogout'" [color]="'primary'" [disabled]="true">
                            </mat-slide-toggle>
                        </div>

                        <!-- Exigir senha para ações financeiras -->
                        <div class="py-4 flex items-center justify-between opacity-50 cursor-not-allowed">
                            <mat-icon class="w-[36px] h-[36px] pb-[10px]" [svgIcon]="'mat_solid:lock'"></mat-icon>
                            <div class="flex-auto ml-2 pr-2">
                                <div class="leading-6">
                                    <span class="text-[15px] font-inter font-[500] text-gray-600">Exigir senha para ações financeiras</span>
                                </div>
                                <div>
                                    <span class="text-[14px] font-inter font-[400] text-gray-500">Solicitar senha antes de realizar operações financeiras sensíveis</span>
                                </div>
                            </div>
                            <mat-slide-toggle class="ml-2 cursor-not-allowed" [formControlName]="'requirePasswordForFinancial'" [color]="'primary'" [disabled]="true">
                            </mat-slide-toggle>
                        </div>
                    </div>
                </div>
            </form>
        </ng-container>
    </div>
</div>
